import { Dictionary, TableRecord } from '@common/types';
import { DICTIONARIES_LIST_FOR_FOCUS_DBLCLICK } from '@modules/planning/children/by-date/constants';

export const focusOnMap = (setTriggerMapFocus: (any: any[]) => void) => (record: TableRecord) => {
  const dictionary = record?.dictionary ?? Dictionary.Empty;
  if (DICTIONARIES_LIST_FOR_FOCUS_DBLCLICK.includes(dictionary)) {
    setTriggerMapFocus([record]);
  }
};
